import { FunctionComponent, useState } from 'react'
import styles from '../export.module.scss'
import { BrowserUpdated } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { ExportDataType } from '@/types/Export'
import ExportDialog from '../exportDialog.tsx'

const ExportTrustees: FunctionComponent = () => {
    const { t } = useTranslation()

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

    return (
        <>
            <a className={styles.Case} onClick={(): void => setIsDialogOpen(true)}>
                <p className={styles.CaseTitle}>{t('trusteeList')}</p>
                <BrowserUpdated className={styles.CaseIcon} />
            </a>
            {isDialogOpen && (
                <ExportDialog
                    type={ExportDataType.Trustees}
                    open={isDialogOpen}
                    handleClose={(): void => setIsDialogOpen(false)}
                    daycares={[]}
                    minDate={''}
                />
            )}
        </>
    )
}

export default ExportTrustees
